import React, { Component } from 'react';
import { Container, Row, Col, Collapse } from 'reactstrap';
import Constants from '../../Constants';
import PubSub from 'pubsub-js';
import EirButton from '../eir-button/EirButton';

class ModalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedAnswer: null,
      answers: [],
      question: '',
      callback: null,
      subscriptionToken: PubSub.subscribe(Constants.eventKeys.modalContentRetrieved, this.handler),
      modalHideToken: PubSub.subscribe(Constants.eventKeys.modalHideRetrieved, this.hideHandler),
      hide: false
    };
  }

  componentWillUnmount() {
    if(this.state.subscriptionToken) {
      PubSub.unsubscribe(this.state.subscriptionToken);
    }
  }

  handler = (msg, data) => {
    this.setState({
      modal: data.isOpen,
      answers: data.answers,
      question: data.question,
      selectedAnswer: data.selectedAnswer,
      callback: data.callback
    });
  };

  hideHandler = (msg, data) => {
    this.setState({
        hide: data
    });
  };

  select = (answer) => {
    this.setState({ modal: false, selectedAnswer: answer });
    PubSub.publish(Constants.eventKeys.modalContentSelected, answer);
  };

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };

  render() {
    return (
      <React.Fragment>
        {(this.state.modal || this.state.selectedAnswer) &&
          <div className={(this.state.hide ? "d-none " : " ") + "eir-modal-container"}>
            <Collapse isOpen={this.state.modal}>
              <Container fluid className=" text-white bg-secondary">
                <Container className="p-4">  
                  <Row>  
                    <Col md="6" className="d-flex align-items-center justify-content-center">
                      <h4 className="text-white text-center text-md-left mb-3 m-md-0">{this.state.question}</h4>
                    </Col>
                  
                    <Col md="6" className="d-flex align-items-center justify-content-center">
                      {this.state.answers.map((answer, index) => {
                        return (
                          <EirButton
                            key={'eir-button-' + index}
                            text={answer.text}
                            type="button"
                            color="white"
                            outline={true}
                            onClick={() => this.select(answer)}
                            className="ml-3 mr-3"
                          />
                        );
                      })}
                    </Col>
                  </Row>  
                </Container>
              </Container>
            </Collapse>
            {this.state.selectedAnswer && 
              <Container fluid>
                <Container  className="d-flex justify-content-end">
                  <EirButton
                    key={'eir-button-'}
                    text={this.state.selectedAnswer ? this.state.selectedAnswer.description : ''}
                    type="button"
                    color="secondary"
                    onClick={this.toggle}
                    icon={this.state.modal ? 'arrowup--white' : 'arrowdown--white'}
                    className="btn-sm eir-modal-toggle d-flex justify-content-center align-items-center"
                  />
                </Container>
              </Container>
            }
          </div>  
        }
      </React.Fragment>
    );
  }
}

export default ModalContainer;